export default __webpack_public_path__ + "static/media/AndhraPradesh_1.0b3c717f.png";